import React from 'react';
import DoctorLetter from './DoctorLetter';
import PharmacistLetter from './PharmacistLetter';
import LettersFormProvider from './provider/LettersFormContext';
import type { DoctorLetterForm, PharmacistLetterForm } from './types';
import type { MedProfile } from '../../hook/types';

import './styles.css';

interface PharmacistDoctorLetterSectionProps {
  medProfile: MedProfile;
  onProvideValues?: (
    getter: () => {
      doctorLetter: DoctorLetterForm;
      pharmacistLetter: PharmacistLetterForm;
    },
  ) => void;
}

export enum LetterType {
  DOCTOR = 'doctor',
  PHARMACIST = 'pharmacist',
}

const PharmacistDoctorLetterSection = ({
  medProfile,
  onProvideValues,
}: PharmacistDoctorLetterSectionProps) => {
  const { isDrLetterIncluded = false, isPharmLetterIncluded = false } =
    medProfile.pdfOptions || {};
  return (
    <LettersFormProvider
      medProfile={medProfile}
      onProvideValues={onProvideValues}
    >
      {isDrLetterIncluded && <DoctorLetter />}
      {isPharmLetterIncluded && <PharmacistLetter />}
    </LettersFormProvider>
  );
};

export default PharmacistDoctorLetterSection;
